import { useSearchParams } from "react-router-dom";
import Login from "app/containers/Login";
import { selectCurrentUserAccountId } from "app/containers/Global/slice";
import { useAppSelector } from "utils/redux/hooks";
import McpConsent from "./McpConsent";
import McpMessageCard from "./McpMessageCard";

/**
 * Hosts the login + consent UI for MCP OAuth. Logged out: the normal Login (its SSO
 * deep-link hook returns here after Okta). Logged in: straight to consent. This page only
 * reads the existing session; it never writes or clears critToken.
 */
function isFramed() {
  try {
    return window.self !== window.top;
  } catch {
    // Reading window.top can throw across origins, which also means we are framed.
    return true;
  }
}

export default function McpAuthorize() {
  const [params] = useSearchParams();
  const flowId = params.get("flow");
  const user = useAppSelector(selectCurrentUserAccountId);

  if (isFramed()) {
    return (
      <McpMessageCard
        title="Open in a new window"
        message="For your security, this page can't be shown inside another page. Open it directly in your browser to continue."
      />
    );
  }
  if (!flowId) {
    return (
      <McpMessageCard
        title="Invalid authorization link"
        message="This link is missing its authorization request. Return to your MCP client and try again."
      />
    );
  }
  if (!user) return <Login />;
  return <McpConsent flowId={flowId} />;
}
